import { render, staticRenderFns } from "./HistoryUpdate.vue?vue&type=template&id=07a71c20&scoped=true"
import script from "./HistoryUpdate.vue?vue&type=script&lang=js"
export * from "./HistoryUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a71c20",
  null
  
)

export default component.exports